<template>
  <body>
    <Header headerColor="black" />
    <CareersContent />
    <Footer />
  </body>
</template>

<script>
import Header from "@/components/SharedComponents/Header.vue";
import CareersContent from "@/components/Careers/CareersContent.vue";
import Footer from "@/components/SharedComponents/Footer.vue";

export default {
  name: "sustainability",
  components: {
    Header,
    CareersContent,
    Footer,
  },
};
</script>
